export default "__VITE_ASSET__Z0KIXb2m__";